import { SavedReport } from "./savedReports.types";

// Reports are built in the background by the API with no failure handling, so
// a build that dies leaves its row at is_ready 0 forever. Only rows this young
// count as still generating when gating Save Report; an older stuck row keeps
// its "Generating…" label but must not block everyone from saving again.
export const GENERATING_BLOCK_WINDOW_MS = 5 * 60 * 1000;

export const isReportGenerating = (
  report: Pick<SavedReport, "is_ready" | "created_on">,
  now: number = Date.now()
) => {
  if (report.is_ready !== 0) return false;
  const created = Date.parse(report.created_on);
  // An unreadable timestamp fails open rather than locking Save Report
  if (Number.isNaN(created)) return false;
  return now - created < GENERATING_BLOCK_WINDOW_MS;
};
